import React from 'react';
import { TooltipProvider } from '@/components/ui/tooltip';
import Sidebar from './Sidebar';
import ConnectionBanner from '@/components/ConnectionBanner';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <TooltipProvider>
      <div className="min-h-screen bg-background">
        <Sidebar />
        <main className="ml-64">
          <ConnectionBanner />
          {children}
        </main>
      </div>
    </TooltipProvider>
  );
};

export default Layout;
